/** @file pivotProposal: where an island's pivot starts: the slot's pivot fraction of the island's box. */
import type { Island } from '@zilo/pose3d-image-io/island/islandTypes';
import type { PlacedPart, Point } from './sheetTypes';

/**
 * The pivot in island pixels (as the island is seen) for `part`: the slot's pivot as a fraction of its tile, applied
 * to the island's box and mirrored when the part is drawn flipped; the box centre for an unused island. The pivot is
 * the node end of the part (the elbow of an upper arm, the neck of a head, the shoulder line of a torso).
 */
export function pivotProposal(island: Pick<Island, 'w' | 'h'>, part: PlacedPart | null): Point {
  if (part === null) return [island.w / 2, island.h / 2];
  const fx = part.pivot[0] / part.size[0];
  return [(part.flip ? 1 - fx : fx) * island.w, (part.pivot[1] / part.size[1]) * island.h];
}
